export const TRIAL_PAGES_FAST_START = 'fast_start';
